import lightbox from '../core/lightbox'

export default function init() {
  lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img')
}
